import { useEffect, useRef } from 'react';

let formRef: HTMLFormElement;
const resizeObserver = new ResizeObserver(([firstEntry]) => {
  if (window !== window.parent) {
    if (firstEntry.target instanceof HTMLFormElement) {
      formRef = firstEntry.target;
    }

    window.parent.postMessage({ type: 'resize', value: formRef.scrollHeight + 2 }, '*');
  }
});

const useResizeObserver = <RefElement extends HTMLElement>() => {
  const ref = useRef<RefElement>(null);

  useEffect(() => {
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        resizeObserver.unobserve(ref.current);
      }
    };
  }, []);

  return ref;
};

export default useResizeObserver;
